
export default function PackagingSection() {

  return (
    <section id="packaging" className="packaging">
      <div className="pack-photo">
      <img src="/assets/packaging.jpeg" alt="The Two of Us colorful packaging with blue box, green envelopes, pink tissue and yellow cards" loading="lazy" />
      </div>
      <div className="pack-copy">
      <img src="/assets/offwhite-logo-mini@4x.png" alt="" className="pack-symbol" />
      <p className="eyebrow">THE OUTSIDE MATTERS, TOO.</p>
      <h2>Joy.<br />All wrapped up.</h2>
      <p>Bright colors. Playful paper. Our signature little loop. A whole world of details that feel like us.</p>
      <p>Because the outside should make you smile, too.</p>
      <span className="small-label">THE TWO OF US / THE UNWRAPPING EDIT</span>
      </div>
      </section>

  );
}
